// extracted by mini-css-extract-plugin
export var logo = "_kx-2";
export var logoWrapper = "_kx-1";
export var strip = "_kx-0";